import React from 'react';
import { Home, BookOpen, Zap, BarChart3, User } from 'lucide-react';

export interface BottomNavItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  badge?: string | number;
}

export interface ReviseBottomNavProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const ReviseBottomNav: React.FC<ReviseBottomNavProps> = ({
  activeTab,
  onTabChange,
}) => {
  const navItems: BottomNavItem[] = [
    { id: 'home', label: 'Home', icon: <Home className="w-5 h-5" /> },
    { id: 'practice', label: 'Practice', icon: <BookOpen className="w-5 h-5" /> },
    { id: 'revision', label: 'REVise', icon: <Zap className="w-5 h-5" /> },
    { id: 'progress', label: 'Progress', icon: <BarChart3 className="w-5 h-5" /> },
    { id: 'account', label: 'Account', icon: <User className="w-5 h-5" /> },
  ];

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-[#E5E9E9] md:hidden shadow-lg">
      <div className="flex items-center justify-around h-16 max-w-md mx-auto px-2">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full py-1 gap-1 transition-all duration-150 cursor-pointer select-none outline-none ${
                isActive
                  ? 'text-[#1fb4ac] font-bold'
                  : 'text-[#5F6368] hover:text-[#111111] font-medium'
              }`}
            >
              <div className="relative">
                <div
                  className={`p-1 rounded-xl transition-all ${
                    isActive ? 'bg-[#E8FAF9] text-[#1fb4ac]' : ''
                  }`}
                >
                  {item.icon}
                </div>
                {item.badge !== undefined && (
                  <span className="absolute -top-1 -right-1.5 w-4 h-4 bg-[#D94A5C] text-white text-[9px] font-extrabold rounded-full flex items-center justify-center">
                    {item.badge}
                  </span>
                )}
              </div>
              <span className="text-[10px] tracking-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
